module.exports = __webpack_public_path__ + "img/3.867647bd.jpeg";